/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksLogic/ChallengeAuthorities/ClearBoardsDailyTripeaksAuthority',[
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/ChallengeConstants',
    'SolitaireShared/CardLogic/IClearBoardsAuthority',
    'SolitaireShared/TriPeaksLogic/IDailyTripeaksAuthority'
], function (IDailyAuthority, ChallengeConstants, IClearBoardsAuthority, IDailyTripeaksAuthority) {
    "use strict";

    var ClearBoardsDailyTripeaksAuthority = function (param) {
        this.initClearBoardsDailyTripeaksAuthority(param);
    };

    ClearBoardsDailyTripeaksAuthority.constructor = ClearBoardsDailyTripeaksAuthority;
    ClearBoardsDailyTripeaksAuthority.prototype = Object.create(IDailyTripeaksAuthority.prototype);
    IClearBoardsAuthority.call(ClearBoardsDailyTripeaksAuthority.prototype);

    ClearBoardsDailyTripeaksAuthority.prototype.initClearBoardsDailyTripeaksAuthority = function (param) {
        IDailyTripeaksAuthority.call(this, param);

        this.SuppressBonusAnimations = true;

        var isDirty = true;
        if (param != null && param[ChallengeConstants.KeyBoardsToClear])
        {
            this.BoardsToClear = parseInt(param[ChallengeConstants.KeyBoardsToClear]);
            isDirty = isNaN(this.BoardsToClear);
        }

        if (isDirty)
            throw "Invalid parameter passed in creating Daily Challenge";


        this.ChallengeType = IDailyAuthority.ChallengeType.ClearBoards;
    };


    ClearBoardsDailyTripeaksAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.WaitingForAnimation)
        {
            // We don't win unless the card animation is finished.
            return false;
        }

        if(this.CardSupply.IsWaitingForAds)
        {
            return false;
        }
//#if !GAMESTATETOOL
        if (!this.CardSupply.IsGamePageLoaded)
        {
            return false;
        }
//#endif

        if (this.CheckWin() && this.BoardsCompleted() < this.BoardsToClear)
        {
            this.Deal();
        }

        return (!this.CardSupply.WaitingForAnimation) && this.BoardsCompleted() >= this.BoardsToClear;
    };

    return ClearBoardsDailyTripeaksAuthority;


});
